module.exports = __webpack_public_path__ + "img/warehouse_img.d56d8937.svg";